export default "__VITE_ASSET__$oGKECdS__"